import { API_BASE_URL } from '../config/api';

const API_URL = API_BASE_URL;

export interface Dietitian {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  bio?: string;
  profileImageUrl?: string;
  specialization?: string;
  education?: string;
  certifications?: string;
  experienceYears?: number;
  languages?: string;
  acceptsOnlineClients?: boolean;
  createdAt: Date;
  updatedAt?: Date;
}

export interface CreateDietitianRequest {
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  bio?: string;
  profileImageUrl?: string;
  specialization?: string;
  acceptsOnlineClients?: boolean;
  termsAcceptedAt?: string;
  termsVersion?: string;
}

export interface UpdateDietitianRequest {
  firstName?: string;
  lastName?: string;
  phone?: string;
  bio?: string;
  profileImageUrl?: string;
  specialization?: string;
  education?: string;
  certifications?: string;
  experienceYears?: number;
  languages?: string;
  acceptsOnlineClients?: boolean;
}

export const dietitianApi = {
  async createDietitian(data: CreateDietitianRequest): Promise<Dietitian> {
    const response = await fetch(`${API_URL}/dietitians`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Diyetisyen oluşturulamadı');
    }
    return await response.json();
  },

  async getDietitianById(id: string): Promise<Dietitian> {
    const response = await fetch(`${API_URL}/dietitians/${id}`);
    if (!response.ok) {
      throw new Error('Diyetisyen bulunamadı');
    }
    return await response.json();
  },

  async getDietitianByEmail(email: string): Promise<Dietitian> {
    const response = await fetch(
      `${API_URL}/dietitians/email/${encodeURIComponent(email)}`
    );
    if (!response.ok) {
      const error: any = new Error('Diyetisyen bulunamadı');
      error.response = response;
      throw error;
    }
    return await response.json();
  },

  async getAllDietitians(): Promise<Dietitian[]> {
    const response = await fetch(`${API_URL}/dietitians`);
    if (!response.ok) {
      throw new Error('Diyetisyenler getirilemedi');
    }
    return await response.json();
  },

  async getOnlineDietitians(): Promise<Dietitian[]> {
    const response = await fetch(`${API_URL}/dietitians/online`);
    if (!response.ok) {
      throw new Error('Online diyetisyenler getirilemedi');
    }
    return await response.json();
  },

  async updateDietitian(
    id: string,
    data: UpdateDietitianRequest
  ): Promise<Dietitian> {
    const response = await fetch(`${API_URL}/dietitians/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error('Diyetisyen güncellenemedi');
    }
    return await response.json();
  },

  async deleteDietitian(id: string): Promise<void> {
    const response = await fetch(`${API_URL}/dietitians/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('Diyetisyen silinemedi');
    }
  },
};

